<!--
 * @Author: your name
 * @Date: 2020-05-16 10:13:37
 * @LastEditTime: 2020-05-21 11:16:06
 * @LastEditors: OBKoro1
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/ResearchPart3.vue
 -->
<template>
  <div class="ResearchPart3" :style="`background: url('${require('../assets/research/bg1.png')}') no-repeat; background-size: 100% 100%;`">
    <div class="body">
        <div v-show="firstPartShow" class="question">
            <div>
                <p class="title">姓名：</p>
                <van-field v-model="q1_1" class="input" placeholder="请输入"/>
            </div>
            <div>
                <p class="title">机构/单位名称：</p>
                <van-field v-model="q1_2" class="input" placeholder="请输入"/>
            </div>
             <div>
                <van-row class="title q_title">机构/单位名称性质？</van-row>
                <van-radio-group v-model="q1_3">
                    <van-radio name="A">医疗卫生行政机关</van-radio>
                    <van-radio name="B">三级公立医院</van-radio>
                    <van-radio name="C">二级公立医院及以下</van-radio>
                    <van-radio name="D">社区卫生服务中心</van-radio>
                    <van-radio name="E">乡镇卫生院</van-radio>
                    <van-radio name="F">民营医院</van-radio>
                </van-radio-group>
            </div>
            <div>
                <van-row class="title q_title">您的职务？</van-row>
                <van-radio-group v-model="q1_4">
                    <van-radio name="A">院长/副院长/书记</van-radio>
                    <van-radio name="B">非临床科室（医务/医保/药剂/院感/医技）管理者</van-radio>
                    <van-radio name="C">临床科室管理者</van-radio>
                    <van-radio name="D">其他</van-radio>
                </van-radio-group>
                 <van-field v-model="q1_4_1" class="input" placeholder="请输入"/>
            </div>
        </div>
        <div v-show="secondPartShow" class="question">
            <div class="title2">【调研内容】</div>
             <div>
                <van-row class="title q_title">1. 您通过何种途径了解并参加了此次线上会议？</van-row>
                <van-radio-group v-model="q2_1">
                    <van-radio name="A">人民健康app</van-radio>
                    <van-radio name="B">朋友圈会议海报</van-radio>
                    <van-radio name="C">他人推荐</van-radio>
                    <van-radio name="D">其他</van-radio>
                </van-radio-group>
                 <van-field v-model="q2_1_1" class="input" placeholder="请输入"/>
            </div>
             <div>
                <van-row class="title q_title">2. 您倾向在线学习呈现的最佳方式？(4选2)</van-row>
                <van-checkbox-group v-model="q2_2">
                    <van-checkbox name="A">图文知识推送</van-checkbox>
                    <van-checkbox name="B">多媒体录播课件</van-checkbox>
                    <van-checkbox name="C">讲师直播互动</van-checkbox>
                    <van-checkbox name="D">其他</van-checkbox>
                </van-checkbox-group>
                 <van-field v-model="q2_2_1" class="input" placeholder="请输入"/>
            </div>
             <div>
                <van-row class="title q_title">3. 您所在的医疗机构是否属于县域医共体？</van-row>
                <van-radio-group v-model="q2_3">
                    <van-radio name="A">是</van-radio>
                    <van-radio name="B">不是</van-radio>
                    <van-radio name="C">不确定</van-radio>
                </van-radio-group>
            </div>
            <div>
                <van-row class="title q_title">4. 希望了解县域医共体建设试点的哪些工作内容？（5选2）</van-row>
                <van-checkbox-group v-model="q2_4">
                    <van-checkbox name="A">完善县域医疗卫生服务体系</van-checkbox>
                    <van-checkbox name="B">深化体制机制改革</van-checkbox>
                    <van-checkbox name="C">提升服务能力和质量</van-checkbox>
                    <van-checkbox name="D">建立健全保障机制</van-checkbox>
                    <van-checkbox name="E">其他</van-checkbox>
                </van-checkbox-group>
                <van-field v-model="q2_4_1" class="input" placeholder="请输入"/>
            </div>
             <div>
                <van-row class="title q_title">5. 关于县域医共体的经验推广模式，您更倾向于以下哪一种？（5选2）</van-row>
                <van-checkbox-group v-model="q2_5">
                    <van-checkbox name="A">线下培训</van-checkbox>
                    <van-checkbox name="B">线上培训、研讨</van-checkbox>
                    <van-checkbox name="C">新闻报道</van-checkbox>
                    <van-checkbox name="D">实地观摩</van-checkbox>
                    <van-checkbox name="E">其他</van-checkbox>
                </van-checkbox-group>
                <van-field v-model="q2_5_1" class="input" placeholder="请输入"/>
            </div>
            <div>
                <van-row class="title q_title">6. 您目前在建设县域医共体过程中还遇到哪些问题？（请填写）</van-row>
                <van-field v-model="q2_6" class="textarea" placeholder="请输入"  type="textarea" rows="6"/>
            </div>
        </div>
        <div v-show="firstPartShow" class="operating">
            <van-button class="upPage" @click="goBack()">上一页</van-button>
            <van-button class="downPage" @click="showSecondPart()">下一页</van-button>
        </div>
         <div v-show="secondPartShow" class="operating">
            <van-button class="upPage" @click="showFirstPart()">上一页</van-button>
            <van-button class="downPage" @click="submitQuestion()">提交问卷</van-button>
        </div>
        <van-popup v-model="qrCodeShow" class="qrCodeShow"  :style="`background: url('${require('../assets/research/bg2.png')}') no-repeat; background-size: 100% 100%;`">
          <div>
                <div class="qrImgDiv">
                <img class="qrImg" src="../assets/research/qrcode.png">
               </div>
              
              <p class="content">微信扫一扫二维码关注公众号
                可在线回看同时学习更多
                基层医疗机构建设相关课程
                或微信搜索公众号“MAP在线”
                关注公众号</p>
              <p class="qrButton">
                  <span class="determine" @click="closeQr()">确定</span>
              </p>
          </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import { Http } from "@/utils/http.js"
import api from "@/config/api.js"
import Cookies from 'js-cookie'

export default {
  name: 'ResearchNoWeChatPart3',
  data() {
    return {
        q1_1:'',
        q1_2: '',
        q1_3: '',
        q1_4: '',
        q2_1: '',
        q2_2: [],
        q2_3: '',
        q2_4: [],
        q2_5: [],
        q2_6: '',
        q1_4_1: '',
        q2_1_1: '',
        q2_2_1: '',
        q2_4_1: '',
        q2_5_1: '',

        firstPartShow: true, // 第一部分
        secondPartShow: false, // 第二部分
        qrCodeShow: false, // 二维码部分 
        isSubmit: false,
        openid : ''
    };
  },
  methods: { 
      // 回历史上一页
      goBack(){
          this.$router.go(-1)
          return 
      },
      // 显示第二部分
      showSecondPart() {
           // 去除空格
          this.q1_4_1 = this.q1_4_1.trim();
            // 判断是否楼选
        const q1_1 = this.isAnswer(1, this.q1_1);
        const q1_2 = this.isAnswer(2, this.q1_2);
        const q1_3 = this.isAnswer(3, this.q1_3);
        const q1_4 = this.isAnswer(4, this.q1_4);

        if (
            !(
            q1_1 &&
            q1_2 &&
            q1_3 &&
            q1_4 
            )
        ) {
            return;
        }

           // 判断是否选了其他，但是还没填其他
      if (q1_4 && this.q1_4 == 'D' && this.q1_4_1.length < 2) {
        this.$dialog.alert({
          message: "请把您的职务的其他的内容也填写一下,内容不能太少"
        });
         this.isSubmit = false
        return;
      }
      
          this.firstPartShow = false
          this.secondPartShow = true
      },
      // 显示第一部分
      showFirstPart() {
          this.secondPartShow = false
          this.firstPartShow = true
      },
      // 关闭二维码弹层
      closeQr() {
         // this.qrCodeShow = false
          this.$router.push({ name: "ResearchNoWeChat"})
      },

      // 判断是否答题
    isAnswer(q, answer) {
    if (answer.length == 0) {
        this.$dialog.alert({
            message: "请确定是否都选择了或填写了"
        });
        return false;
    }
    return true;
    },
    // 弹框
    customAlert(msg){
    this.$dialog.alert({
        message: msg
    });
    return
    },
      // 提交答案
    submitQuestion() {
        if(this.isSubmit){
            this.customAlert('正在提交')
            return false
        }
        this.isSubmit = true
        // 去除空格
        this.q1_4_1 = this.q1_4_1.trim();
        this.q2_1_1 = this.q2_1_1.trim();
        this.q2_2_1 = this.q2_2_1.trim();
        this.q2_4_1 = this.q2_4_1.trim();
        this.q2_5_1 = this.q2_5_1.trim();

        // 判断是否楼选
        const q1_1 = this.isAnswer(1, this.q1_1);
        const q1_2 = this.isAnswer(2, this.q1_2);
        const q1_3 = this.isAnswer(3, this.q1_3);
        const q1_4 = this.isAnswer(4, this.q1_4);
        const q2_1 = this.isAnswer(1, this.q2_1);
        const q2_2 = this.isAnswer(2, this.q2_2);
        const q2_3 = this.isAnswer(3, this.q2_3);
        const q2_4 = this.isAnswer(4, this.q2_4);
        const q2_5 = this.isAnswer(5, this.q2_5);
        const q2_6 = this.isAnswer(6, this.q2_6);

        if (
            !(
            q1_1 &&
            q1_2 &&
            q1_3 &&
            q1_4 &&
            q2_1 &&
            q2_2 &&
            q2_3 &&
            q2_4 &&
            q2_5 &&
            q2_6     
            )
        ) {
            this.isSubmit = false
            return;
        }


       // 判断是否选了其他，但是还没填其他
      if (q1_4 && this.q1_4 == 'D' && this.q1_4_1.length < 2) {
        this.$dialog.alert({
          message: "请把您的职务的其他的内容也填写一下,内容不能太少"
        });
         this.isSubmit = false
        return;
      }
         // 判断是否选了其他，但是还没填其他
      if (q2_1 && this.q2_1 == 'D' && this.q2_1_1.length < 2) {
        this.$dialog.alert({
          message: "请把第1题的其他的内容也填写一下,内容不能太少"
        });
         this.isSubmit = false
        return;
      }

           // 判断是否选了其他，但是还没填其他
      if (q2_2 && this.q2_2.includes("D") && this.q2_2_1.length < 2) {
        this.$dialog.alert({
          message: "请把第2题的其他的内容也填写一下,内容不能太少"
        });
         this.isSubmit = false
        return;
      }


      // 判断是否选了其他，但是还没填其他
      if (q2_4 && this.q2_4.includes("E") && this.q2_4_1.length < 2) {
        this.$dialog.alert({
          message: "请把第4题的其他的内容也填写一下,内容不能太少"
        });
         this.isSubmit = false
        return;
      }

       // 判断是否选了其他，但是还没填其他
      if (q2_5 && this.q2_5.includes("E") && this.q2_5_1.length < 2) {
        this.$dialog.alert({
          message: "请把第5题的其他的内容也填写一下,内容不能太少"
        });
         this.isSubmit = false
        return;
      }

      if(this.q2_2.length != 2){
        this.$dialog.alert({
          message: "第2题只能选2项"
        });
         this.isSubmit = false
        return;
      }

      if(this.q2_4.length != 2){
        this.$dialog.alert({
          message: "第4题只能选2项"
        });
         this.isSubmit = false
        return;
      }

        if(this.q2_5.length != 2){
        this.$dialog.alert({
          message: "第5题只能选2项"
        });
         this.isSubmit = false
        return;
      }
      
      // 提交数据
        // 提交数据
      let data = {};
      let answer = {};
      answer.q1_1 = this.q1_1;
      answer.q1_2 = this.q1_2;
      answer.q1_3 = this.q1_3;
      answer.q1_4 = this.q1_4;
      
      answer.q2_1 = this.q2_1;
      answer.q2_2 = this.q2_2;
      answer.q2_3 = this.q2_3;
      answer.q2_4 = this.q2_4;
      answer.q2_5 = this.q2_5;
      answer.q2_6 = this.q2_6;

      answer.q1_4_1 = this.q1_4_1;
      answer.q2_1_1 = this.q2_1_1;
      answer.q2_2_1 = this.q2_2_1;
      answer.q2_4_1 = this.q2_4_1;
      answer.q2_5_1 = this.q2_5_1;


      data.openid = ''
      data.wx_name = ''
      data.wx_sex = ''
      data.wx_province = ''
      data.wx_city = ''
      data.answer = answer;

      console.log(data)

      Http.post(api.addResearchOther, data).then((response) => {
            this.isSubmit = false
            this.qrCodeShow = true
            return false
      })
    }

  },

  mounted: function() {
    // this.openid = Cookies.get('openid')
    // // 跳转到首页
    // if(!this.openid){
    //     this.$router.push({ name: "ResearchPart3"})
    // }
  },
}
</script>

<style lang="less">
.ResearchPart3 {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    .body {
        .question {
            // opacity: 0.8;
            // background: #FFFFFF;
            background-color: rgba(255,255,255,0.8)!important;
            background-color: #FFF;
            filter:Alpha(opacity=80);

            border-radius: 10px;
            border-radius: 10px;
            padding: 12px 16px;
            padding-bottom: 24px;
            margin: 10px 10px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #000000;
            letter-spacing: 0;
            .title {
                font-family: PingFangSC-Medium;
                color: #000000;
            }
            .title2 {
                font-family: PingFangSC-Medium;
                font-size: 20px;
                color: #3671EA;
                letter-spacing: 0;
                text-align: center;
            }
            .input {
                border: 1px solid #8B8B8B;
                border-radius: 8px;
                border-radius: 8px;
                padding: 5px 8px;
                opacity: 0.5;
            }
            .textarea {
                border: 1px solid #8B8B8B;
                border-radius: 8px;
                border-radius: 8px;
                padding: 5px 8px;
            }
            .q_title {
                margin-top: 12px;
                margin-bottom: 12px;
            }
            .van-radio {
                margin-bottom: 12px;
                font-size: 12px;
                font-family: PingFangSC-Regular;
            }
            .van-radio__icon {
                font-size: 12px;
            }
            .van-checkbox {
                margin-bottom: 12px;
                font-size: 12px;
                font-family: PingFangSC-Regular;
            }
            .van-checkbox__icon {
                font-size: 12px;
            }
        }
        .operating {
            text-align: center;
            margin-bottom: 24px;
            .upPage {
                background: #FFFFFF;
                border-radius: 40px;
                border-radius: 40px;
                width: 36%;
                height: 45px;
            }
            .downPage {
                background: #F6A763;
                border-radius: 40px;
                border-radius: 40px;
                width: 36%;
                height: 45px;
            }
        }
     }
    .qrCodeShow {
        width: calc(100% - 40px);
        border-radius: 4px;
        box-sizing: border-box;
        margin: 0 auto;
        text-align: center;
        .qrImgDiv{
            .qrImg {
                width: 160px;
            }
        }
        .content {
            font-size: 16px;
            white-space: pre-line;
            color: #fff;
        }
        .qrButton {
            background: #FFFFFF;
            border-radius: 45px;
            border-radius: 45px;
            width: 160px;
            height: 32px;
            margin: 0 auto;
            margin-bottom: 24px;
            line-height: 32px;
            font-size: 16px;
            font-family: PingFangSC-Regular;
            color: #012C9C;
            letter-spacing: 0;
        }

    }
     .van-button--default {
        border: 1px solid #1d74f7;
     }
     .van-icon {
        border: 1px solid #8B8B8B
     }
}
</style>


// WEBPACK FOOTER //
// src/components/ResearchNoWeChatPart3.vue